<script setup lang="ts">
    import { Combobox, InputRow, SectionHeader } from '@/components/ui/form';
    import type { OutlayCompany } from '@/types';
    import { computed } from 'vue';

    const props = defineProps<{
        form: any;
        outlayCompanies: OutlayCompany[];
        isPendingOutlayCompanies: boolean;
    }>();

    const outlayCompanyOptions = computed(() => {
        return props.outlayCompanies.map((item: OutlayCompany) => {
            const isSelected = item.keepers !== null && item.keepers.id === props.form.id;

            const name =
                item.outlay.vat !== ''
                    ? `${item.outlay.id}: ${item.outlay.name} - ${item.outlay.vat}`
                    : `${item.outlay.id}: ${item.outlay.name}`;

            return {
                value: item.outlay.id,
                label: name,
                addon: !isSelected && item.keepers !== null ? `(${item.keepers.name})` : '',
            };
        });
    });
</script>

<template>
    <div class="space-y-5">
        <SectionHeader>{{ $t('companies.outlay_tab_text') }}</SectionHeader>
        <div class="grid gap-3 sm:grid-cols-1">
            <InputRow
                :form="form"
                name="outlay_company_id"
                label="companies.form.outlay_company_id"
            >
                <Combobox
                    v-model="form.outlay_company_id"
                    :options="outlayCompanyOptions"
                    :placeholder="$t('companies.outlay.deselect')"
                    :loading="isPendingOutlayCompanies"
                />
            </InputRow>
        </div>
    </div>
</template>
